<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M96.1661 24H31.8339C20.8799 24 12 32.8799 12 43.8339V83.2786C12 94.2326 20.8799 103.112 31.8339 103.112H96.1661C107.12 103.112 116 94.2326 116 83.2786V43.8339C116 32.8799 107.12 24 96.1661 24Z"
    />
    <path
      d="M116 43.4993H12V58.9762H116V43.4993Z"
      fill="#CB80DE"
    />
    <path
      d="M96.6487 92.3727C100.871 92.3727 104.294 88.9497 104.294 84.7272C104.294 80.5047 100.871 77.0816 96.6487 77.0816C92.4262 77.0816 89.0032 80.5047 89.0032 84.7272C89.0032 88.9497 92.4262 92.3727 96.6487 92.3727Z"
      fill="#CB80DE"
    />
    <path
      d="M81.3492 92.3727C85.5717 92.3727 88.9947 88.9497 88.9947 84.7272C88.9947 80.5047 85.5717 77.0816 81.3492 77.0816C77.1266 77.0816 73.7036 80.5047 73.7036 84.7272C73.7036 88.9497 77.1266 92.3727 81.3492 92.3727Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ConsumerLoan'
  }
</script>
